@if (surveyEditorService.surveyEditor$().activeQuestion; as activeQuestion) {
  <div [formGroup]="activeQuestion" class="ai-chat-settings__container">
    <mat-slide-toggle
      [labelPosition]="'before'"
      [color]="'primary'"
      data-testid="ai-chat-allow-voice-toggle"
      formControlName="allowVoiceResponsesInd"
      [checked]="activeQuestion.value.allowVoiceResponsesInd"
    >
      Allow voice responses
    </mat-slide-toggle>

    <span class="text__sm">Participants can speak their answers; audio is transcribed to text. </span>

    <mat-divider></mat-divider>

    <div class="ai-chat-settings__note" [class.ai-chat-settings__note--alert]="!activeQuestion.value.allowVoiceResponsesInd">
      @if (activeQuestion.value.allowVoiceResponsesInd) {
        <fa-icon [icon]="faShieldCheck"></fa-icon>
        <span>Voice recordings may be treated as PII under GDPR/CCPA. Disable this for clients that prohibit audio capture.</span>
      } @else {
        <fa-icon [icon]="faExclamationCircle"></fa-icon>
        <span>Participants can only respond by typing. No audio is captured, processed, or stored for this question.</span>
      }
    </div>
  </div>
}
